import { Controller } from "@hotwired/stimulus"

// On a phone the sidebar slides in over the page (data-nav="open" on the
// shell) from the menu button, and closes from its own close button.
export default class extends Controller {
  static targets = ["toggle"]

  toggle() {
    this.element.dataset.nav === "open" ? this.close() : this.open()
  }

  open() {
    this.element.dataset.nav = "open"
    this.toggleTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.element.dataset.nav = "closed"
    this.toggleTarget.setAttribute("aria-expanded", "false")
  }
}
